/* @ngInject */
const wagonUtils = (
  valueHandler
) => {
  const self = {}

  self.autocontrole = (_id) => {
    if (valueHandler.isEmpty(_id) || !valueHandler.isString(_id)) {
      return null
    }

    _id = _id.replace(/\s/g, '')

    if (!_id.match(new RegExp(/[0-9]{11}/))) {
      return null
    }

    let res = 0
    const number = _id.toString()
    let digit = 0
    let temp, temp2

    for (let i = 0; i < number.length; i++) {
      temp2 = 0
      digit = parseInt(number[i])
      i % 2 === 0 ? temp = digit * 2 : temp = digit
      if (temp >= 10) {
        temp2 = 1
        temp = temp - 10
      }
      res += temp + temp2
    }
    return (10 - (res % 10)) % 10
  }

  self.getPossibleId = (_partialId) => {
    _partialId = _partialId.toString()
    if (valueHandler.isEmpty(_partialId) || _partialId.length !== 13) {
      return false
    }
    let nbMissing = 0
    const index = []
    const res = []

    let i, j

    for (i = 0; i < _partialId.length; i++) {
      if (_partialId[i] === ' ') {
        index[nbMissing] = i
        nbMissing += 1
      }
    }

    let partialId = _partialId.toString()

    let autocontrole

    for (j = 0; j < Math.pow(10, nbMissing); j++) {
      for (i = 0; i < nbMissing; i++) {
        partialId[index[i]] = (j / Math.pow(10, i)) % 10
      }

      if (_partialId[12] === ' ') {
        partialId = partialId.splice(12, 1)
      } else {
        partialId = partialId.splice(12, 1)

        autocontrole = self.autocontrole(partialId)

        if (autocontrole === _partialId[12]) {
          res.push('' + partialId + autocontrole)
        }
      }
    }
    return res
  }

  self.idToString = (_id) => {
    if (_id === undefined || _id === null || _id === '') {
      return _id
    }

    let res = ''
    res += _id.toString().slice(0, 2)
    res += ' ' + _id.toString().slice(2, 4)
    res += ' ' + _id.toString().slice(4, 7)
    res += ' ' + _id.toString().slice(7, 11)
    res += ' - ' + _id.toString().slice(11, 12)

    return res
  }

  self.stringToId = (_id) => {
    if (valueHandler.isEmpty(_id)) {
      return null
    }
    return _id.replace(/\s/g, '').replace(/-/g, '')
  }

  self.isIdValid = (_id) => {
    if (valueHandler.isEmpty(_id)) {
      return false
    }

    _id = _id.replace(/\s/g, '').replace(/-/g, '')

    if (_id.match(new RegExp('^[0-9]{12}$'))) {
      const autocontrole = _id.slice(11, 12)
      const supposedAutocontrole = '' + self.autocontrole(_id.slice(0, 11))
      if (autocontrole === supposedAutocontrole) {
        return true
      }
    }
    return false
  }

  return self
}

export default wagonUtils



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/services/utils.service.js